export default __webpack_public_path__ + "static/media/car.7781b7b4.png";